import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isGlobalAdmin, isOrgAdmin, isInstitutionAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Allow access for any admin role (global, org, or institution admin)
  const isAdmin = isGlobalAdmin || isOrgAdmin || isInstitutionAdmin || user?.user_type === 'admin';
  
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
